import styled from "styled-components";
import { Form } from "antd";

export const FieldItem = styled(Form.Item)`
  margin-bottom: 20px;

  .ant-form-item-label {
    padding: 0 0 6px;
  }

  .ant-form-item-label > label {
    height: auto;
    color: rgba(0, 0, 0, 0.88);
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
  }

  .ant-form-item-label > label.ant-form-item-required::before {
    color: #f5222d;
  }

  .ant-form-item-tooltip {
    color: rgba(0, 0, 0, 0.45);
  }

  .ant-form-item-explain-error {
    font-family: "Open Sans", sans-serif;
    font-size: 12px;
    line-height: 20px;
    color: #f5222d;
  }
`;

export const LabelWithTooltip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

export const RequiredMark = styled.span`
  color: #f5222d;
  margin-left: 2px;
`;
